import LoaderModule from './loader.module'

export default LoaderModule
